import { render } from "./HomeHeader.vue?vue&type=template&id=470146f4&scoped=true"
import script from "./HomeHeader.vue?vue&type=script&lang=js"
export * from "./HomeHeader.vue?vue&type=script&lang=js"

import "./HomeHeader.vue?vue&type=style&index=0&id=470146f4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470146f4"]])

export default __exports__